import { Injectable } from '@nestjs/common';
import {ExpensesCategoryDTO} from './expenses-category.dto';
import {ExpensesCategory} from '../expenses-category.entity';

@Injectable()
export class ExpensesCategoryAdapter {
  
  public convertDtoToEntity(expensesCategoryDTO: ExpensesCategoryDTO,  isUpdate: boolean = false ): ExpensesCategory {
    const expensesCategories = new ExpensesCategory();
    expensesCategories.expensesCategoryId=expensesCategoryDTO.expensesCategoryId;
    expensesCategories.expensesCategory=expensesCategoryDTO.expensesCategory;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    expensesCategories.isActive=expensesCategoryDTO.isActive==undefined?true:expensesCategoryDTO.isActive;
    if (isUpdate) {
        expensesCategories.updatedUser = expensesCategoryDTO.updatedUser;
    } else {
        expensesCategories.isActive = true;
        expensesCategories.createdUser = expensesCategoryDTO.createdUser;
    }
   return expensesCategories;
  }
  public convertEntityToDto(expensesCategoryObject: ExpensesCategory): ExpensesCategoryDTO {
    const expensesCategoryDto= new ExpensesCategoryDTO;
    expensesCategoryDto.expensesCategoryId=expensesCategoryObject.expensesCategoryId;
    expensesCategoryDto.expensesCategory=expensesCategoryObject.expensesCategory;
    expensesCategoryDto.isActive = expensesCategoryObject.isActive;
    expensesCategoryDto.createdAt = expensesCategoryObject.createdAt;
    expensesCategoryDto.updatedAt = expensesCategoryObject.updatedAt;
    expensesCategoryDto.createdUser = expensesCategoryObject.createdUser;
    expensesCategoryDto.updatedUser = expensesCategoryObject.updatedUser;
    expensesCategoryDto.versionFlag = expensesCategoryObject.versionFlag;
    return expensesCategoryDto;
  }
}
